<div class="pdf-view-container" [ngClass]="(!signing && signable) ? 'not-signed' : 'signed'">
    <div *ngIf="showControls">
        <button mat-icon-button (click)="zoom(0.1)" title="{{'common.zoomInBtn' | transloco}}">+</button>
        <button mat-icon-button (click)="zoom(-0.1)" title="{{'common.zoomOutBtn' | transloco}}">-</button>
        <button mat-icon-button (click)="printpdf()" title="{{'common.printBtn' | transloco}}">{{'common.printBtn' | transloco}}</button>
        <button mat-icon-button (click)="saveFile()" title="{{'common.download' | transloco}}">{{'common.download' | transloco}}</button>
    </div>

    <!-- Signature Status Banner (Adobe-style) -->
    <div class="sig-status-banner" *ngIf="showSignaturePanel && pdfSignatures.length > 0 && sigBannerVisible">
        <button mat-icon-button class="sig-banner-close" (click)="sigBannerVisible = false">
            <mat-icon>close</mat-icon>
        </button>
        <span class="sig-banner-text">
            {{ signatureBannerText }}
        </span>
        <button mat-stroked-button class="sig-panel-btn" (click)="openSignaturePanel()">
            {{ 'pdfWrapper.pdfWrapper.signaturePanelLbl' | transloco }}
        </button>
    </div>

    <div class="pdf-load-error" *ngIf="loadError">
        {{ 'pdfWrapper.pdfWrapper.loadErrorLbl' | transloco }}
    </div>
    <pdf-viewer *ngIf="!loadError && pdfViewerVisible" [(page)]="page" [src]="pdfSrc" [show-all]="showAll" [render-text]="true" [autoresize]="true" [original-size]="false"
        [zoom]="pdfZoom" [fit-to-page]="autoSize" (after-load-complete)="afterLoadComplete($event)" (error)="onError($event)" #pdfViewer></pdf-viewer>

    <!-- Signature Detail Panel (modal) -->
    <div class="sig-panel-backdrop" *ngIf="showSignaturePanel && pdfSignatures.length > 0 && sigPanelExpanded" (click)="closeSignaturePanel()">
    <div class="pdf-signatures-panel" *ngIf="showSignaturePanel && pdfSignatures.length > 0 && sigPanelExpanded" (click)="$event.stopPropagation()">
        <div class="sig-panel-header">
            <mat-icon class="sig-panel-lock">lock</mat-icon>
            <span class="sig-panel-title">{{ 'pdfWrapper.pdfWrapper.signaturePanelLbl' | transloco }}</span>
            <span class="sig-spacer"></span>
            <button mat-icon-button class="sig-panel-close" (click)="closeSignaturePanel()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="sig-panel-body">
            <div class="sig-entry" *ngFor="let sig of pdfSignatures; let i = index">
                <div class="sig-entry-icon">
                    <mat-icon [class.sig-icon-valid]="sig.status === 'valid'"
                              [class.sig-icon-warn]="sig.status !== 'valid'">
                        {{ sig.status === 'valid' ? 'verified' : 'help_outline' }}
                    </mat-icon>
                </div>
                <div class="sig-entry-body">
                    <div class="sig-entry-title">{{ sig.role ? getRoleLabel(sig.role) : ('pdfWrapper.pdfWrapper.signatureNumberLbl' | transloco: { number: i + 1 }) }}</div>
                    <table class="sig-detail-table">
                        <tr>
                            <td class="sdt-label">{{ 'common.signatureType' | transloco }}</td>
                            <td class="sdt-value">
                                <ng-container *ngIf="sig.isDigitalCertificate; else noLicensed">
                                    {{ 'pdfWrapper.pdfWrapper.digitalSignatureLbl' | transloco }}
                                </ng-container>
                                <ng-template #noLicensed>
                                    {{ 'pdfWrapper.pdfWrapper.electronicSignatureLbl' | transloco }}
                                </ng-template>
                            </td>
                        </tr>
                        <tr *ngIf="sig.signer">
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.signedByLbl' | transloco }}</td>
                            <td class="sdt-value">{{ sig.signer }}</td>
                        </tr>
                        <tr *ngIf="sig.cuil">
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.taxIdLbl' | transloco }}</td>
                            <td class="sdt-value">{{ sig.cuil }}</td>
                        </tr>
                        <tr *ngIf="sig.signedDate">
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.dateTimeLbl' | transloco }}</td>
                            <td class="sdt-value">{{ sig.signedDate | date:'dd/MM/yyyy HH:mm' }}</td>
                        </tr>
                        <tr *ngIf="sig.certSubject">
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.certificateHolderLbl' | transloco }}</td>
                            <td class="sdt-value">{{ sig.certSubject }}</td>
                        </tr>
                        <tr *ngIf="sig.certIssuer">
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.issuedByLbl' | transloco }}</td>
                            <td class="sdt-value">{{ sig.certIssuer }}</td>
                        </tr>
                        <tr *ngIf="sig.certValidFrom || sig.certValidTo">
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.certificateValidityLbl' | transloco }}</td>
                            <td class="sdt-value">
                                {{ sig.certValidFrom | date:'dd/MM/yyyy' }} - {{ sig.certValidTo | date:'dd/MM/yyyy' }}
                            </td>
                        </tr>
                        <tr *ngIf="!sig.certValidFrom && !sig.certValidTo && !sig.isDigitalCertificate">
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.certificateValidityLbl' | transloco }}</td>
                            <td class="sdt-value">{{ 'pdfWrapper.pdfWrapper.notApplicableNoCertificateLbl' | transloco }}</td>
                        </tr>
                        <tr>
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.statusLbl' | transloco }}</td>
                            <td class="sdt-value sdt-status">
                                <mat-icon class="sdt-status-icon"
                                          [class.sig-icon-valid]="sig.hasAppearance"
                                          [class.sdt-icon-warn]="!sig.hasAppearance">
                                    {{ sig.hasAppearance ? 'check_circle' : 'radio_button_unchecked' }}
                                </mat-icon>
                                {{ sig.hasAppearance ? ('pdfWrapper.pdfWrapper.visualAppearanceVerifiedLbl' | transloco) : ('pdfWrapper.pdfWrapper.signedWithoutAppearanceLbl' | transloco) }}
                            </td>
                        </tr>
                        <tr *ngIf="sig.rect">
                            <td class="sdt-label">{{ 'pdfWrapper.pdfWrapper.locationLbl' | transloco }}</td>
                            <td class="sdt-value">{{ 'pdfWrapper.pdfWrapper.pageLbl' | transloco: { page: sig.page } }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    </div>
</div>
